App.factory('SmartCommand', ['restmod', restmod => {
  return restmod.model().mix({ location: { belongsTo: 'Location'} });
}]);
